import useTranslation from 'next-translate/useTranslation';

export const useFirebaseErrorMessages = () => {
    const { t } = useTranslation('common');

    return {
        'auth/invalid-verification-code': t('invalidVerificationCode'),
        'auth/credential-already-in-use': t('credentialAlreadyInUse'),
        'auth/code-expired': t('expiredCode'),
    };
};
